












































































































































import { Component, Prop, PropSync, Ref } from 'nuxt-property-decorator'
import { repeat, forEachRight } from 'lodash'
import { ComponentVue } from '@/base'
import { ModalEditMemoAndNote } from '@/components/modals/ModalEditMemoAndNote'
import {
  alertStore,
  authUserStore,
  modalErrorStore
} from '@/utils/store-accessor'
import {
  AlertMessage,
  ErrorMessage,
  userApi,
  UserMemo,
  UserNote,
  UserOfMemosAndNote
} from '@/api'
import { IButtonToggleItem } from '@/components/molecules/ButtonToggle/ButtonToggle.type'
import { ButtonToggle } from '@/components/molecules/ButtonToggle'

export interface UserMemoAndNoteItem {
  id: string
  memos: UserMemo[]
  notes: UserNote[]
}

export const defaultUserMemoAndNoteItem = (): UserMemoAndNoteItem => ({
  id: '',
  memos: [],
  notes: []
})

@Component({
  components: {
    ButtonToggle,
    ModalEditMemoAndNote
  }
})
export default class UserMemoAndNote extends ComponentVue {
  @Ref()
  modalEditMemoAndNote!: ModalEditMemoAndNote

  @PropSync('item', {
    type: Object,
    required: true
  })
  contentItem!: UserMemoAndNoteItem

  @Prop({
    type: Number,
    required: true
  })
  bodyHeight!: number

  @Prop({
    type: Boolean,
    default: true
  })
  editable!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabledEditButton!: boolean

  display: boolean = true

  get cssCustomProperty(): any {
    return {
      '--table-body-height': this.display ? this.bodyHeight + 'px' : '0px'
    }
  }

  get toggleItems(): IButtonToggleItem[] {
    return [
      { value: true, text: '表示' },
      { value: false, text: '非表示' }
    ]
  }

  get existsNotes(): boolean {
    return !!this.notesCount
  }

  get memosCount(): number {
    return this.contentItem.memos.length
  }

  get notesCount(): number {
    return this.contentItem.notes.length
  }

  get reverseMemos(): UserMemo[] {
    const results: UserMemo[] = []
    forEachRight<UserMemo>(this.contentItem.memos, (memo: UserMemo) =>
      results.push(memo)
    )

    return results
  }

  get reverseNotes(): UserNote[] {
    const results: UserNote[] = []
    forEachRight<UserNote>(this.contentItem.notes, (note: UserNote) =>
      results.push(note)
    )

    return results
  }

  get isAuthUserGroupUserOnlyReference(): boolean {
    return authUserStore.isAuthUserGroupUserOnlyReference
  }

  onClickEdit(): void {
    this.refreshMemo()
    this.modalEditMemoAndNote.open()
  }

  async refreshMemo(): Promise<void> {
    try {
      const memosAndNotes: UserOfMemosAndNote = await userApi.getMemosAndNoteById(
        this.contentItem.id
      )
      this.contentItem.memos = memosAndNotes.memos
      this.contentItem.notes = memosAndNotes.notes

      this.$emit('updated')
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      }
    }
  }

  alignDigits(str: string): string {
    if (str === '0') return ''

    const alignDigitsTargetCount: number =
      this.memosCount > this.notesCount ? this.memosCount : this.notesCount

    return repeat('0', String(alignDigitsTargetCount).length - str.length)
  }

  displayNoDesc(value: number, total: number) {
    const count: string = total - value + ''
    return this.alignDigits(count) + count
  }

  convertArray(value: string): string[] {
    const spacingCount: number = 50
    const results: string[] = []

    for (let count = 0; count < value.length / spacingCount; count++) {
      const startCount: number = count * spacingCount

      results.push(value.slice(startCount, startCount + spacingCount))
    }

    return results
  }
}
